import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ApiRequestService, UserInfoService } from 'app/BaseFramework';
import { DataTransformService } from 'app/ViewModules/shared-services';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-reassign-task',
  templateUrl: './reassign-task.component.html',
  styleUrls: ['./reassign-task.component.scss']
})
export class ReassignTaskComponent implements OnInit {
  constructor(
    private message: NzMessageService,
    private notification: NzNotificationService,
    private router: Router,
    private userInfoService: UserInfoService,
    public dataTransformService: DataTransformService,
    private apiRequestService: ApiRequestService,
  ) {

  }
  applicableQueueFl: boolean = false
  holidayFl: boolean = false
  oooFl: boolean = false
  reporteeFl: boolean = false
  filterfl : boolean = true;

  selectedTasks: any[]
  isAssigningSingleTask: boolean = false
  @Input() set tasksList(value) {
    if (value && value.length > 0) {
      this.selectedTasks = value
      this.checkForMultipleWorkqueues()
      this.getUsers(false, false)
    }
  }
  @Output() closeModal = new EventEmitter<void>();

  ngOnInit(): void {
    console.log(this.tasksList)
  }
  disableApplicableQueueFl: boolean = false
  totalListOfUsers: any[]
  listOfUsers: any[]
  messageId
  getUsers(fromFilter, fromReset) {
    if(this.messageId) this.message.remove(this.messageId)
    let workQueues = this.selectedTasks.map(task => task.workQueue)
    let IO = {
      "size": "20",
      "searchCriteriaList": [
        {
          "paramName": "queueCd",
          "paramValue": this.applicableQueueFl ? workQueues[0] : null
        },
        {
          "paramName": "holidayFl",
          "paramValue": this.holidayFl
        },
        {
          "paramName": "oooFl",
          "paramValue": this.oooFl
        },
        {
          "paramName": "userId",
          "paramValue": this.reporteeFl ? this.userInfoService.getUserId() : null
        },
      ]
    }
    if (workQueues && workQueues.length > 0) {
      this.apiRequestService.postCallWithAPIMapper('fetchReassignmentUsers', IO).subscribe(res => {
        if (res.results && res.results.length > 0) {
          this.totalListOfUsers = res.results
          this.listOfUsers = res.results
          this.listOfUsers.forEach(item => {
            let styles = {
              backgroundColor: this.returnRandomColor(),
              color: 'white',
              position: 'relative'
            };
            item['avatarStyle'] = styles
          })
          if (fromReset && !this.messageId) this.messageId = this.message.success("All Filters reset Sucessfully.", { nzDuration: 4000 })
          if (fromFilter && !this.messageId) this.messageId = this.message.success("Selected Filters are applied Sucessfully.", { nzDuration: 4000 })
        } else {
          this.totalListOfUsers = res.results
          this.listOfUsers = res.results
          this.message.info("No Users Found.")
        }
      })
    }
  }
  checkForMultipleWorkqueues() {
    let workQueues = this.selectedTasks.map(task => task.workQueue)
    let uniqueworkQueues = new Set(workQueues)
    if (uniqueworkQueues.size > 1) {
      this.disableApplicableQueueFl = true
      this.message.warning("You can't select user by workqueue as you have selected Tasks with different workqueues.", { nzDuration: 4000 })
    }
  }

  resetFilter() {
    this.applicableQueueFl = false
    this.oooFl = false
    this.holidayFl = false
    this.reporteeFl = false
    this.getUsers(false, true)
    this.filterfl = true;
  }
  
  enableFilter() {
    this.filterfl = !(this.applicableQueueFl || this.oooFl || this.holidayFl || this.reporteeFl);
  }

  crossCheckApplicalbilityandReportee(event, changedField) {
    if (changedField == 'applicableQueueFl' && this.reporteeFl) {
      this.message.warning("you can't select applicable queues and reportees together, Please select one.", { nzDuration: 4000 })
      this.applicableQueueFl = false
    }
    if (changedField == 'reporteeFl' && this.applicableQueueFl) {
      this.message.warning("you can't select applicable queues and reportees together, Please select one.", { nzDuration: 4000 })
      this.reporteeFl = false
    }
  }


  users
  colorArray=['#7D0A0A', '#034C53', '#410445', '#809D3C', '#131D4F', '#006A71'];
  returnRandomColor(){
    let randonIndex = Math.floor(Math.random()*this.colorArray.length);
    return this.colorArray[randonIndex];
  }
  reAssignTask() {
    if (!!!this.users)
      this.notification.warning('No data selected.', 'Please select at least one user.');
    else {
      let listTaskIDs = this.selectedTasks.map(task => task.taskGuid ? task.taskGuid : task.guid)
      let IO = {
        taskGuids: listTaskIDs,
        userId: this.users,
        remarks: this.remarks
      }
      this.apiRequestService.postCallWithAPIMapper('reAssignTaskToUser', IO)
        .subscribe(resp => {
          this.closeModal.emit()
          setTimeout(() => {
            this.message.success("Task Assigned Successfully.", { nzDuration: 3000 })
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/app/nbu/inbox/workbench']);
            });

            // this.router.navigate(['/app/claims/inbox/workbench'])
          }, 300);
        })
    }
  }
  remarks: string = '';
  cancel(): void {
    console.log("Transaction reassignment canceled.");
    this.resetForm();
    this.closeModal.emit()
  }

  resetForm(): void {
    this.disableApplicableQueueFl = false
    this.applicableQueueFl = false
    this.oooFl = false
    this.holidayFl = false
    this.reporteeFl = false
    this.users = null
    this.remarks = null
  }
}
